'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Pressable.module.css';
/**
 * Headless press-target. Renders a `<button>` that forwards every prop —
 * including event handlers and data-/aria-attributes — so it composes
 * cleanly with `asChild`-style triggers (Radix DropdownMenu, Popover,
 * Dialog) and any other library that injects handlers via cloneElement.
 *
 * Use when `Button` doesn't fit — e.g. an avatar+chevron chip with custom
 * surrounding layout. Visual styling comes entirely from `className`.
 */
export const Pressable = forwardRef(function Pressable({ type = 'button', className, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, className: className ? `${styles.pressable} ${className}` : styles.pressable, ...rest }));
});
//# sourceMappingURL=Pressable.js.map